export const PAYMENT_MODE_OPTIONS = [
  {
    value: 'normal',
    label: 'پرداخت عادی',
    description: 'پرداخت از طریق درگاه بانکی.',
  },
  {
    value: 'secure',
    label: 'پرداخت امن',
    description: 'وجه تا تأیید دریافت نزد پلتفرم نگه داشته می‌شود؛ این امانت‌داری بانکی نیست.',
  },
  {
    value: 'cheque',
    label: 'پرداخت چکی',
    description: 'پیش‌پرداخت و اطلاعات چک پس از پرداخت ثبت می‌شود.',
  },
  {
    value: 'installment',
    label: 'پرداخت اقساطی',
    description: 'ادامهٔ درخواست از طریق ارائه‌دهندهٔ پرداخت.',
  },
];

export const PAYMENT_MESSAGES = {
  methodHeading: 'روش پرداخت',
  gatewayUnavailable: 'اتصال به درگاه پرداخت برقرار نشد، دوباره تلاش کنید',
  kalabargUnavailable: 'موجودی کالابرگ برای تکمیل پرداخت کافی نیست.',
  genericError: 'پرداخت انجام نشد. لطفاً دوباره تلاش کنید.',
  pending: 'در حال بررسی پرداخت...',
  pendingTimeout: 'نتیجه پرداخت هنوز مشخص نیست، بعداً از بخش سفارش‌ها بررسی کنید',
  failure: 'پرداخت ناموفق بود.',
  expired: 'مهلت پرداخت به پایان رسیده است.',
  receiptUsed: 'این رسید قبلاً استفاده شده است.',
  refundNote: 'اگر مبلغ از حساب شما کسر شده است، برای پیگیری با پشتیبانی تماس بگیرید.',
  paymentOptionUnavailable: 'این روش پرداخت دیگر در دسترس نیست. روش دیگری را انتخاب کنید.',
  noAvailablePaymentOption: 'در حال حاضر روش پرداختی در دسترس نیست.',
  multiVendorUnavailable: 'برای سبد چندفروشنده‌ای در دسترس نیست.',
  platformItemsUnavailable: 'برای سبد دارای کالای پلتفرم در دسترس نیست.',
  paymentNotRequired: 'برای این سفارش پرداختی لازم نیست.',
  sellerGatewayUnavailable: 'این روش پرداخت در حال حاضر در دسترس نیست. روش دیگری را انتخاب کنید.',
  pendingModeMismatch: 'برای این سفارش پرداختی با روش دیگری در انتظار است. می‌توانید وضعیت سفارش را ببینید یا تا پایان مهلت پرداخت صبر کنید.',
  paymentContextUnavailable: 'روش پرداخت این سفارش در دسترس نیست؛ برای جلوگیری از آغاز روش نادرست، پرداخت انجام نشد.',
  paymentOptionsLoading: 'در حال بررسی روش‌های پرداخت...',
  paymentOptionsError: 'روش‌های پرداخت دریافت نشد. دوباره تلاش کنید.',
  orderPaymentUnavailable: 'این سفارش دیگر برای پرداخت باز نیست. وضعیت سفارش را بررسی کنید.',
  payOrder: 'پرداخت سفارش',
  orderPaymentStatusAria: 'وضعیت پرداخت',
  paymentOptionsAria: 'گزینه‌های پرداخت',
  chequePrepaymentAria: 'پیش‌پرداخت چکی',
  backToCart: 'بازگشت به سبد خرید',
  continuePayment: 'ادامه پرداخت',
  preparingPayment: 'در حال آماده‌سازی پرداخت...',
  retryPayment: 'تلاش مجدد برای پرداخت',
  paymentSummary: 'خلاصه سفارش',
  productAmount: 'مبلغ محصولات',
  shippingCost: 'هزینه ارسال',
  payableAmount: 'مبلغ قابل پرداخت',
  chequePrepaymentLabel: 'مبلغ پیش‌پرداخت (تومان)',
  chequeCountLabel: 'تعداد چک‌ها',
  chequeAmountLabel: 'مبلغ چک (تومان)',
  addCheque: 'افزودن چک',
  removeCheque: 'حذف چک',
  chequePlanUnavailable: 'اطلاعات چک‌های مورد انتظار از سفارش دریافت نشد؛ مبلغ‌ها را وارد کنید تا سرور بررسی کند.',
  chequeCountError: 'تعداد چک باید بین {min} و {max} باشد.',
  chequePrepaymentError: 'پیش‌پرداخت باید دست‌کم {minimum} تومان باشد.',
  chequeWholeUnitsError: 'مبلغ پیش‌پرداخت و چک‌ها را به واحد کامل تومان وارد کنید.',
  chequePositiveAmountError: 'مبلغ هر چک باید بیشتر از صفر باشد.',
  chequePlanMismatchError: 'مجموع مبلغ پیش‌پرداخت و چک‌ها با مبلغ سفارش برابر نیست.',
  chequeRegistrationMismatchError: 'مبلغ چک‌ها با طرح ثبت‌شدهٔ سفارش برابر نیست.',
  chequeOrderChanged: 'وضعیت ثبت چک‌ها تغییر کرده است. صفحه را تازه‌سازی و دوباره بررسی کنید.',
  invalidChequeDetailsError: 'مبلغ، تاریخ سررسید و شناسهٔ هر چک را بررسی کنید.',
  chequeRegistrationFailed: 'ثبت اطلاعات چک انجام نشد. اطلاعات را بررسی و دوباره تلاش کنید.',
  chequeDueDateLabel: 'تاریخ سررسید',
  chequeReferenceLabel: 'شناسه یا شمارهٔ چک',
  registerCheques: 'ثبت اطلاعات چک‌ها',
  registeringCheques: 'در حال ثبت اطلاعات چک‌ها...',
  chequeRegistrationComplete: 'اطلاعات چک ثبت شد و برای تأیید به فروشنده ارسال شد.',
  chequeDecisionTitle: 'تصمیم دربارهٔ چک‌ها',
  chequeConfirmDecision: 'تأیید چک‌ها',
  chequeRejectDecision: 'رد چک‌ها',
  chequeDecisionConfirmBody: 'با تأیید، سفارش برای ادامهٔ پردازش در اختیار فروشنده قرار می‌گیرد.',
  chequeDecisionRejectBody: 'با رد چک‌ها، سفارش لغو می‌شود و بازپرداخت پیش‌پرداخت باید دستی انجام شود.',
  chequeDecisionError: 'ثبت تصمیم چک‌ها انجام نشد. وضعیت سفارش را تازه‌سازی کنید.',
  chequeRetryUnavailable: 'اطلاعات پیش‌پرداخت چکی در این مرورگر موجود نیست؛ از جزئیات سفارش وضعیت را بررسی کنید.',
  idempotencyConflict: 'این کلید درخواست قبلاً با اطلاعات دیگری استفاده شده است. اطلاعات را بررسی و دوباره ارسال کنید.',
  refundReasonReturn: 'برگشت کالا',
  refundReasonRejected: 'رد کالا توسط فروشنده',
  refundReasonCancelled: 'لغو پس از پرداخت',
  refundReasonUnreversed: 'برگشت‌نخورده در درگاه',
  refundReasonCheque: 'لغو پیش‌پرداخت چکی',
  refundReasonRecovery: 'بازیابی بازپرداخت مستقیم فروشنده',
  refundReasonColumn: 'دلیل',
  liabilityTotalColumn: 'مبلغ مسئولیت',
  refundTitle: 'بازگشت وجه',
  refundIntro: 'ثبت بازپرداخت‌هایی که خارج از سامانه انجام شده‌اند',
  refundManualNote: 'بازپرداخت وجه خارج از سامانه انجام می‌شود و این صفحه فقط سابقهٔ آن را ثبت می‌کند.',
  pendingRefundsTitle: 'بازپرداخت‌های در انتظار',
  refundRequestsLoading: 'در حال دریافت درخواست‌ها...',
  orderNumberColumn: 'شماره سفارش',
  customerMobileColumn: 'موبایل مشتری',
  refundedAmountColumn: 'مبلغ بازپرداخت‌شده',
  remainingRefundAmountColumn: 'ماندهٔ قابل‌پرداخت',
  orderDateColumn: 'تاریخ سفارش',
  selectRefundAmount: 'انتخاب',
  refundRegistrationTitle: 'ثبت بازگشت وجه',
  refundOrderNumberLabel: 'شماره سفارش',
  refundVendorOrderLabel: 'شناسهٔ زیرسفارش (برای برگشت کالا)',
  refundReasonLabel: 'دلیل',
  refundAmountLabel: 'مبلغ (تومان)',
  refundBankReferenceLabel: 'شمارهٔ پیگیری بانکی',
  refundNoteLabel: 'یادداشت (اختیاری)',
  submittedRefundsTitle: 'بازگشت‌وجه‌های ثبت‌شده',
  refundHistoryLoading: 'در حال دریافت سوابق...',
  unknownRefundReason: 'نامشخص',
  confirmPayoutAmount: 'پرداخت این مبلغ به فروشنده را تأیید می‌کنید؟',
  payoutConflict: 'اطلاعات درخواست با وضعیت فعلی مغایرت دارد. صفحه را تازه‌سازی و دوباره بررسی کنید.',
  payoutComplete: 'پرداخت فروشنده ثبت شد.',
  payoutSubmit: 'ثبت پرداخت',
  payoutBankReferenceLabel: 'شمارهٔ پیگیری بانکی',
  payoutNoteLabel: 'یادداشت',
  orderActionFailed: 'بروزرسانی وضعیت با خطا مواجه شد',
  confirmAdjustmentAmount: 'ثبت این تعدیل در دفتر کل را تأیید می‌کنید؟ مبلغ می‌تواند بدهی یا بستانکاری باشد.',
  adjustmentTitle: 'تعدیل دفتر کل فروشنده',
  adjustmentAmountLabel: 'مبلغ تعدیل (تومان؛ مثبت یا منفی)',
  adjustmentReasonLabel: 'شرح تعدیل',
  adjustmentFieldsRequired: 'مبلغ غیرصفر و شرح تعدیل را وارد کنید.',
  adjustmentFailed: 'ثبت تعدیل انجام نشد. اطلاعات را بررسی و دوباره تلاش کنید.',
  adjustmentComplete: 'تعدیل دفتر کل ثبت شد.',
  adjustmentSubmit: 'ثبت تعدیل',
  confirmRefundAmount: 'ثبت دستی بازپرداخت این مبلغ را تأیید می‌کنید؟',
  refundFailed: 'ثبت بازپرداخت انجام نشد. اطلاعات را بررسی و دوباره تلاش کنید.',
  refundComplete: 'بازپرداخت ثبت شد.',
  confirmRecoveryAmount: 'ثبت بازیابی این مبلغ از فروشنده را تأیید می‌کنید؟',
  recoveryTitle: 'ثبت بازپرداخت مستقیم فروشنده و بازیابی از دفتر کل',
  recoveryAmountLabel: 'مبلغ بازیابی (تومان)',
  recoveryFieldsRequired: 'شناسهٔ سفارش، شناسهٔ زیرسفارش و مبلغ مثبت را وارد کنید.',
  recoveryFailed: 'ثبت بازیابی انجام نشد. سفارش، زیرسفارش و مبلغ را بررسی کنید.',
  recoveryComplete: 'بازیابی بازپرداخت ثبت شد.',
  recoverySubmit: 'ثبت بازیابی',
  orderIdLabel: 'شناسهٔ سفارش',
  vendorOrderIdLabel: 'شناسهٔ زیرسفارش فروشنده',
  bankReferenceLabel: 'شمارهٔ پیگیری بانکی',
  noteLabel: 'یادداشت (اختیاری)',
  confirmShippingAmount: 'پرداخت این مبلغ هزینهٔ ارسال را تأیید می‌کنید؟',
  shippingPaymentFailed: 'ثبت پرداخت هزینهٔ ارسال انجام نشد. فهرست را تازه‌سازی و دوباره بررسی کنید.',
  confirmGatewayConfig: 'تغییر پیکربندی درگاه فروشنده را تأیید می‌کنید؟',
  gatewayConfigTitle: 'پیکربندی درگاه SEP فروشنده',
  vendorIdLabel: 'شناسهٔ فروشنده',
  gatewayEnabledLabel: 'درگاه فروشنده فعال باشد',
  terminalIdLabel: 'شناسهٔ ترمینال SEP',
  terminalConfiguredLabel: 'ترمینال پیکربندی شده',
  terminalLastDigitsLabel: 'رقم‌های پایانی ترمینال',
  negativeBalanceLimitLabel: 'حد منفی مانده (فقط‌خواندنی)',
  gatewayLoad: 'دریافت پیکربندی',
  gatewaySave: 'ذخیرهٔ پیکربندی',
  gatewayCredentialRefLabel: 'ارجاع اعتبارنامه در مخزن امن',
  gatewayCredentialSet: 'ثبت ارجاع اعتبارنامه',
  gatewayCredentialRotate: 'چرخش ارجاع اعتبارنامه',
  gatewayCredentialNeverShown: 'مقدار ارجاع اعتبارنامه پس از ثبت نمایش داده نمی‌شود.',
  gatewayConfigFailed: 'دریافت یا ذخیرهٔ پیکربندی درگاه انجام نشد.',
  vendorIdInvalid: 'شناسهٔ فروشنده معتبر نیست.',
  credentialRefRequired: 'ارجاع اعتبارنامه را وارد کنید.',
  gatewayConfigSaved: 'پیکربندی درگاه ذخیره شد.',
  gatewayCredentialSaved: 'ارجاع اعتبارنامه ثبت شد.',
  gatewayEnabled: 'فعال',
  gatewayDisabled: 'غیرفعال',
  yes: 'بله',
  no: 'خیر',
  auditTitle: 'گزارش عملیات مالی ادمین',
  auditRefresh: 'تازه‌سازی گزارش',
  auditLoadMore: 'دریافت موارد بیشتر',
  auditEmpty: 'عملیات مالی ثبت‌شده‌ای وجود ندارد.',
  auditError: 'دریافت گزارش عملیات مالی انجام نشد.',
  auditDateColumn: 'تاریخ',
  auditActorColumn: 'عامل',
  auditActionColumn: 'عملیات',
  auditTargetColumn: 'هدف',
  auditBeforeColumn: 'پیش از تغییر',
  auditAfterColumn: 'پس از تغییر',
  auditKeyColumn: 'کلید درخواست',
  sellerGatewayNav: 'درگاه فروشندگان',
  auditNav: 'گزارش عملیات مالی',
  mutationPending: 'در حال ثبت...',
  paymentModeUnavailable: 'روش پرداخت این تراکنش مشخص نیست؛ برای جلوگیری از آغاز روش نادرست، تلاش دوباره ممکن نیست.',
  viewPendingOrder: 'مشاهدهٔ سفارش',
  waitForPendingPayment: 'بازگشت به فهرست سفارش‌ها',
  chequeTermsRequired: 'برای پرداخت چکی، ابتدا مبلغ پیش‌پرداخت و مبلغ چک‌ها را ثبت کنید.',
  unpaid: 'پرداخت‌نشده',
  prepaidAwaitingCheque: 'پیش‌پرداخت انجام شده؛ در انتظار تأیید چک‌ها',
  paid: 'پرداخت‌شده',
  cancelledWithRefundDue: 'لغو شده؛ بازپرداخت در انتظار انجام',
  secureAwaitingReceipt: 'در انتظار تأیید دریافت',
  secureConfirmed: 'سفارش تکمیل شد؛ دریافت تأیید شده است.',
  secureNotReceived: 'گزارش دریافت‌نشدن ثبت شد؛ بازپرداخت در انتظار انجام',
  secureHoldingNotice: 'وجه تا تأیید دریافت نزد پلتفرم نگه داشته می‌شود؛ این امانت‌داری بانکی نیست.',
  secureNotReceivedExplanation: 'سفارش لغو شده است و بازپرداخت باید به‌صورت دستی انجام شود.',
  confirmReceiptAction: 'تأیید دریافت',
  notReceivedAction: 'گزارش عدم دریافت',
  confirmReceiptDialogTitle: 'تأیید دریافت سفارش',
  confirmReceiptDialogBody: 'با تأیید، وجه پرداختی برای فروشنده آزاد می‌شود. فقط زمانی تأیید کنید که همهٔ اقلام باقی‌مانده را دریافت کرده‌اید.',
  notReceivedDialogTitle: 'گزارش عدم دریافت',
  notReceivedDialogBody: 'با ثبت این گزارش، سفارش لغو می‌شود و بازپرداخت باید به‌صورت دستی انجام شود.',
  secureReceiptWaitForDelivery: 'پس از تحویل همهٔ اقلام باقی‌مانده می‌توانید دریافت را تأیید کنید.',
  secureReceiptItemsNotDelivered: 'برای تأیید دریافت، ابتدا باید همهٔ اقلام باقی‌مانده تحویل داده شده باشند.',
  secureOrderChanged: 'وضعیت سفارش تغییر کرده است. وضعیت به‌روز شد؛ دوباره بررسی کنید.',
  secureActionError: 'ثبت تغییر وضعیت سفارش ممکن نشد. دوباره تلاش کنید.',
  secureConfirm: 'تأیید و ادامه',
  secureReportNotReceived: 'ثبت گزارش',
  secureCancel: 'بازگشت',
  secureActionPending: 'در حال ثبت...',
  chequeAwaitingRegistration: 'در انتظار ثبت اطلاعات چک',
  chequeAwaitingConfirmation: 'در انتظار تأیید فروشنده',
  chequeConfirmed: 'چک‌ها تأیید شدند',
  chequeRejected: 'چک‌ها رد شدند',
  chequeTimedOut: 'مهلت تأیید چک‌ها پایان یافت.',
  chequeDecisionDeadline: 'مهلت تصمیم‌گیری:',
};
